'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.SortedSource = void 0;
var tslib_1 = require("tslib");
var SortedSource = /** @class */ (function () {
    function SortedSource(settings) {
        this._storage = new Map();
        if (settings) {
            this.add(settings);
        }
    }
    SortedSource.prototype.select = function (key, filter) {
        var settings = this._storage.get(key);
        if (!settings) {
            return;
        }
        if (!filter) {
            return settings[0];
        }
        return settings.find(filter);
    };
    SortedSource.prototype.selectAll = function (key, filter) {
        var settings;
        if (key) {
            settings = this._storage.get(key) || [];
        }
        else {
            settings = tslib_1.__spreadArray([], tslib_1.__read(this._storage.values()), false).flat();
        }
        if (filter) {
            return settings.filter(filter);
        }
        return tslib_1.__spreadArray([], tslib_1.__read(settings), false);
    };
    SortedSource.prototype.add = function (newSettings) {
        var e_1, _a;
        if (!newSettings.length) {
            return;
        }
        var _loop_1 = function (newSetting) {
            var settings = this_1._storage.get(newSetting.key);
            if (settings) {
                var index = settings.findIndex(function (setting) { return setting.priority <= newSetting.priority; });
                if (index >= 0) {
                    settings.splice(index, 0, newSetting);
                }
                else {
                    settings.push(newSetting);
                }
            }
            else {
                this_1._storage.set(newSetting.key, [newSetting]);
            }
        };
        var this_1 = this;
        try {
            for (var newSettings_1 = tslib_1.__values(newSettings), newSettings_1_1 = newSettings_1.next(); !newSettings_1_1.done; newSettings_1_1 = newSettings_1.next()) {
                var newSetting = newSettings_1_1.value;
                _loop_1(newSetting);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (newSettings_1_1 && !newSettings_1_1.done && (_a = newSettings_1.return)) _a.call(newSettings_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    SortedSource.prototype.removeByKeys = function (settingKeys) {
        var e_2, _a;
        try {
            for (var settingKeys_1 = tslib_1.__values(settingKeys), settingKeys_1_1 = settingKeys_1.next(); !settingKeys_1_1.done; settingKeys_1_1 = settingKeys_1.next()) {
                var _b = settingKeys_1_1.value, key = _b.key, priority = _b.priority;
                var settings = this._storage.get(key);
                if (!settings || !settings.length) {
                    continue;
                }
                var removeCount = 0;
                var startIndex = -1;
                for (var i = 0; i < settings.length; i++) {
                    var setting = settings[i];
                    if (setting.priority > priority) {
                        continue;
                    }
                    if (setting.priority < priority) {
                        break;
                    }
                    if (startIndex === -1) {
                        startIndex = i;
                    }
                    removeCount++;
                }
                if (startIndex !== -1) {
                    settings.splice(startIndex, removeCount);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (settingKeys_1_1 && !settingKeys_1_1.done && (_a = settingKeys_1.return)) _a.call(settingKeys_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    SortedSource.prototype.replaceAll = function (settings) {
        var prevStorage = this._storage;
        try {
            this._storage = new Map();
            this.add(settings);
        }
        catch (error) {
            this._storage = prevStorage;
            throw error;
        }
    };
    Object.defineProperty(SortedSource.prototype, "snapshot", {
        // FIXME: Этот хак необходим, чтобы из воркера пробросить отсортированный Map
        get: function () {
            return this._storage;
        },
        enumerable: false,
        configurable: true
    });
    return SortedSource;
}());
exports.SortedSource = SortedSource;
//# sourceMappingURL=SortedSource.js.map
